var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassengerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.731 1.64316C23.6425 1.64316 26.0024 4.00166 26.0024 6.91092C26.0024 9.82018 23.6425 12.1787 20.731 12.1787V13.8217C24.5506 13.8217 27.6469 10.7276 27.6469 6.91092C27.6469 3.09423 24.5506 0.00012207 20.731 0.00012207V1.64316Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7317 13.8222C26.2605 13.8222 30.7425 18.3011 30.7425 23.8261H32.387C32.387 17.3936 27.1687 12.1793 20.7321 12.1793L20.7317 13.8222Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6967 1.64311C15.8186 1.64311 18.3491 4.17189 18.3491 7.29128C18.3491 10.411 15.8186 12.9397 12.6967 12.9397C9.57518 12.9397 7.04464 10.411 7.04464 7.29128C7.04464 4.17189 9.57518 1.64311 12.6967 1.64311ZM19.9931 7.29128C19.9931 3.26439 16.7265 0 12.6967 0C8.66705 0 5.40039 3.26432 5.40039 7.29128C5.40039 11.3185 8.66698 14.5826 12.6967 14.5826C16.7267 14.5826 19.9931 11.3182 19.9931 7.29128Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6966 14.5835C18.5995 14.5835 23.3846 19.3651 23.3846 25.264H25.0288C25.0288 18.4581 19.5074 12.9406 12.6968 12.9406C5.88611 12.9406 0.364746 18.4581 0.364746 25.264H2.0092C2.0092 19.3652 6.79417 14.5835 12.6965 14.5835H12.6966Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassengerIcon);
export default __webpack_public_path__ + "static/media/passengerIcon.0ee31d69ea7086587c77ec52ad6e9d17.svg";
export { ForwardRef as ReactComponent };